function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_3239",
  "data-name": "Group 3239"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1357",
  "data-name": "Path 1357",
  d: "M424.335,597.058V626.9l-9.777-4.115-4.63-9.431v-6.173l3.773-6.516Z",
  transform: "translate(-369.542 -515.347)",
  fill: "#f2f6f9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1358",
  "data-name": "Path 1358",
  d: "M619.805,597.058V626.9l-9.777-4.115-4.63-9.431v-6.173l3.773-6.516Z",
  transform: "translate(-380.461 -515.347)",
  fill: "#f2f6f9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1359",
  "data-name": "Path 1359",
  d: "M797.446,516.429l28.3-5.916V657.385l-29.315-6.846c-2.947-2.6-25.414-18.074-35-38.134-6.163-12.894-5.536-48.941-3.322-56.622,1.7-5.9,9.681-7.7,11.317-13.375C772.215,532.711,796.178,520.828,797.446,516.429Z",
  transform: "translate(-388.903 -510.513)",
  fill: "#f5f8fa"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_3236",
  "data-name": "Group 3236",
  transform: "translate(434.007 143.27)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_1",
  "data-name": "Line 1",
  y2: 190.626,
  transform: "translate(2.833 0)",
  fill: "#cbd2d9"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_2226",
  "data-name": "Rectangle 2226",
  width: 5.665,
  height: 190.626,
  fill: "#cbd2d9"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_3237",
  "data-name": "Group 3237",
  transform: "translate(402.46 331.063)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_2",
  "data-name": "Line 2",
  x2: 63.095,
  transform: "translate(2.832 2.833)",
  fill: "#cbd2d9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1360",
  "data-name": "Path 1360",
  d: "M859.351,866.828H796.256a2.832,2.832,0,1,1,0-5.665h63.094a2.832,2.832,0,1,1,0,5.665Z",
  transform: "translate(-793.424 -861.163)",
  fill: "#cbd2d9"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_3238",
  "data-name": "Group 3238",
  transform: "translate(365.78 2.133)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1361",
  "data-name": "Path 1361",
  d: "M891.406,609.019a4.935,4.935,0,0,1-1.455,3.513L854.333,648.15a4.937,4.937,0,0,1-3.513,1.456H800.447a4.937,4.937,0,0,1-3.513-1.456l-35.619-35.619a4.935,4.935,0,0,1-1.455-3.513V558.647a4.937,4.937,0,0,1,1.455-3.514l35.619-35.618a4.934,4.934,0,0,1,3.513-1.456H850.82a4.933,4.933,0,0,1,3.513,1.456l35.619,35.618a4.937,4.937,0,0,1,1.455,3.514v50.372Zm-33.335-93.242a10.189,10.189,0,0,0-7.252-3H800.447a10.189,10.189,0,0,0-7.252,3l-35.619,35.618a10.192,10.192,0,0,0-3,7.253v50.372a10.189,10.189,0,0,0,3,7.252L793.2,651.889a10.189,10.189,0,0,0,7.252,3H850.82a10.189,10.189,0,0,0,7.252-3l35.619-35.619a10.189,10.189,0,0,0,3-7.252V558.647a10.193,10.193,0,0,0-3-7.253l-35.619-35.618Z",
  transform: "translate(-754.573 -512.772)",
  fill: "#cbd2d9"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_1362",
  "data-name": "Path 1362",
  d: "M832.331,542.905A24.157,24.157,0,0,0,808.2,567.034v22.489l-3.335-3.794a2.856,2.856,0,1,0-4.291,3.77l8.337,9.487a2.854,2.854,0,0,0,2.145.971h.025a2.856,2.856,0,0,0,2.154-1.008l8.049-9.486a2.856,2.856,0,0,0-4.355-3.7l-3.016,3.554V567.034a18.417,18.417,0,0,1,36.834,0v52.873a2.856,2.856,0,0,0,5.712,0V567.034A24.157,24.157,0,0,0,832.331,542.905Z",
  transform: "translate(-391.323 -512.322)",
  fill: "#00a0af"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1363",
  "data-name": "Path 1363",
  d: "M437.888,655.723l-70.735,70.732,8.745,3.6,74.851-74.337Z",
  transform: "translate(-367.153 -518.624)",
  fill: "#f2f6f9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1364",
  "data-name": "Path 1364",
  d: "M483.343,655.723l-70.735,70.732,8.745,3.6L496.2,655.723Z",
  transform: "translate(-369.692 -518.624)",
  fill: "#f2f6f9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1365",
  "data-name": "Path 1365",
  d: "M528.84,655.723,458.1,726.454l8.745,3.6L541.7,655.723Z",
  transform: "translate(-372.233 -518.624)",
  fill: "#f2f6f9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1366",
  "data-name": "Path 1366",
  d: "M620.924,655.723l-70.736,70.732,8.745,3.6,74.851-74.337Z",
  transform: "translate(-377.377 -518.624)",
  fill: "#f2f6f9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1367",
  "data-name": "Path 1367",
  d: "M666.421,655.723l-70.735,70.732,9.821,2.537,67.323-66.86Z",
  transform: "translate(-379.918 -518.624)",
  fill: "#f2f6f9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1368",
  "data-name": "Path 1368",
  d: "M574.882,655.723l-70.736,70.732,8.746,3.6,74.851-74.337Z",
  transform: "translate(-374.805 -518.624)",
  fill: "#f2f6f9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1369",
  "data-name": "Path 1369",
  d: "M659.293,649.385H610.284V629.816a18.118,18.118,0,1,0-5.785-.111v19.68H424.838V629.761a18.321,18.321,0,1,0-5.785,0v19.624H370.045a2.89,2.89,0,0,0-2.892,2.893v73.589a2.89,2.89,0,0,0,2.892,2.892H395.4V846.026H375.695a2.892,2.892,0,1,0,0,5.785h45.194a2.892,2.892,0,1,0,0-5.785h-19.7v-87.74H628.153v87.74h-19.7a2.892,2.892,0,1,0,0,5.785h45.194a2.892,2.892,0,1,0,0-5.785H633.938V728.758h25.355a2.89,2.89,0,0,0,2.893-2.892V652.277A2.891,2.891,0,0,0,659.293,649.385ZM595.4,611.735a12.536,12.536,0,1,1,12.536,12.533A12.549,12.549,0,0,1,595.4,611.735Zm-185.994,0a12.536,12.536,0,1,1,12.536,12.533A12.549,12.549,0,0,1,409.41,611.735ZM587.038,722.974l67.8-67.8H656.4v33.571l-34.23,34.233Zm-43.314,0,67.8-67.8h35.133l-67.8,67.8Zm-43.308,0,67.8-67.8h35.128l-67.8,67.8Zm-43.314,0,67.8-67.8h35.133l-67.8,67.8Zm-43.313,0,67.8-67.8h35.134l-67.8,67.8ZM372.938,677.2,394.97,655.17H430.1l-57.165,57.163ZM386.79,655.17l-13.852,13.852V655.17Zm-13.852,65.343,65.346-65.343h35.128l-67.8,67.8h-32.67ZM628.153,752.5H401.185V728.758H628.153Zm2.2-29.526L656.4,696.922v26.052Z",
  transform: "translate(-367.153 -515.144)",
  fill: "#cbd2d9"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_56",
  "data-name": "Ellipse 56",
  cx: 6.169,
  cy: 6.169,
  r: 6.169,
  transform: "translate(48.801 90.03)",
  fill: "#00a0af"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_57",
  "data-name": "Ellipse 57",
  cx: 6.169,
  cy: 6.169,
  r: 6.169,
  transform: "translate(234.619 90.03)",
  fill: "#00a0af"
}));

var SvgPermissionsRequired = function SvgPermissionsRequired(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Illustration_-_Permissions_needed",
    "data-name": "Illustration - Permissions needed",
    width: 507.9,
    height: 336.728,
    viewBox: "0 0 507.9 336.728",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPermissionsRequired, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/permissionsRequired.5af36a09.svg";
export { ForwardRef as ReactComponent };